export enum CaseTypes {
  PAPER = "Бумажное",
  HYBRID = "Гибридное",
  ELECTRONIC = "Электронное",
}
